<script setup lang="ts">
import Button from "@/components/Reusables/Buttons/Button.vue";
import { useModalStore } from "@/stores/modals/modals.store";

const modals = useModalStore();
const { closeByName } = modals;

withDefaults(
  defineProps<{
    heading: string;
    message: string;
    confirmLabel?: string;
    cancelLabel?: string;
    confirmColor?:
      | "primary"
      | "button"
      | "destructive"
      | "super-cta"
      | "super-cta-primary"
      | "disabled"
      | "inline"
      | "inline-destructive";
  }>(),
  {
    confirmLabel: "Confirm",
    cancelLabel: "Cancel",
    confirmColor: "destructive",
  }
);

const handleConfirm = async () => {
  closeByName("ModalConfirm", { action: "confirm" });
};

const handleCancel = () => {
  closeByName("ModalConfirm", { action: "cancel" });
};
</script>

<template>
  <div class="flex flex-col gap-4">
    <h2 class="text-lg font-semibold">{{ heading }}</h2>
    <span>{{ message }}</span>
    <div class="flex justify-between">
      <Button
        :label="cancelLabel"
        color="button"
        @click="handleCancel" />
      <Button
        :label="confirmLabel"
        :color="confirmColor"
        @click="handleConfirm" />
    </div>
  </div>
</template>
